import {Button} from '@/components/ui/button/Button'
import {Bell01Icon} from '@/components/ui/icon/Icon'
import {useState, useCallback} from 'react'
import {NotificationsModal} from '@/features/notifications/components/notifications-modal/NotificationsModal'
import {NotificationBadge} from '../notification-badge/NotificationBadge'

export const NotificationButton = () => {
    const [isModalOpen, setIsModalOpen] = useState(false)

    // Using useCallback to memoize the handler functions
    const handleOpenModal = useCallback(() => {
        setIsModalOpen(true)
    }, [])

    const handleCloseModal = useCallback(() => {
        setIsModalOpen(false)
    }, [])

    return (
        <>
            <NotificationBadge onNotificationClickCb={handleOpenModal}>
                <Button variant="ghost" size="sm" shape="square">
                    <Bell01Icon />
                </Button>
            </NotificationBadge>
            <NotificationsModal isOpen={isModalOpen} onClose={handleCloseModal} />
        </>
    )
}
